import React, { ChangeEvent, useEffect, useRef, useState } from "react";
import AccordionComponent from "../../../../common/Accordion";
import {
  Button,
  Col,
  Container,
  Form,
  Modal,
  OverlayTrigger,
  Row,
  ToggleButton,
  ToggleButtonGroup,
  Tooltip,
} from "react-bootstrap";
import {
  PICKLIST_GROUP_NAME,
  RATE_TYPE,
  WEB_ROLE,
} from "../../../../common/Constant";
import { useSelector } from "react-redux";
import { RootState } from "../../../../redux/Store";
import { fetchPickListByGroupName } from "../../../../services/CaseInformationApi";
import SearchableSingleSelectDropdown from "../../../../common/SearchableDropdown";
import SearchableMultiSelectDropdown from "../../../../common/SearchableMultiSelectDropdown";
import NumberInput from "../../../../common/NumberInput";
import FloatingLabelDatepicker from "../../../../common/DatePicker";
import MultilineTextBox from "../../../../common/MultilineTextBox";
import Loader from "../../../../common/Loader";
import Snackbar from "../../../../common/Snackbar";
import {
  formatAppointmentDateTime,
  formatDateTime,
} from "../../../../utils/dateUtils";
import {
  fetchBillingConfigurationDetails,
  fetchUerListByCase,
  fetchUerListByTeam,
  fetchUerListByTenantID,
  getBillingConfigChangeLog,
  getCaseLevelBillingChangeLog,
  getCaseLevelBillingDetails,
  updateBillingConfig,
} from "../../../../services/BillingConfigApi";
import ThresholdEditableTable from "../../Billing/components/Configuration/PageThresholdEditable";
import ThresholdLineEditable from "../../Billing/components/Configuration/LineThresholdEditable";
import ChangeLogDrawer from "../../Billing/components/Configuration/ChangeLogDrawer";
import {
  BILLING_CONFIG_CHANGE_LOG,
  BILLINGCASE_CONFIG_CHANGE_LOG,
} from "../../Billing/actions/constant";
import BillingDataTable from "../../Billing/components/BillingDataTable";
import {
  addTeamBilling,
  fetchTeamBillingDetails,
  getTeamBillingChangeLog,
  updateTeamBilling,
} from "../../../../services/BillingAPI";
import BillingTeamsEditableTable from "./BillingTeamsEditableTable";
import { fetcheaderinfo } from "../../../../services/UserRegistrationApi";

interface UserOptiopn {
  userId?: number;
  usfUlNameRole?: string;
}

const AddUpdateBilling = ({ teamId, onClose, selectedData }: any) => {
  const userID = useSelector((state: RootState) => state.auth.userid);
  const datePickerRef = useRef<HTMLDivElement>(null);
  const [selectedBillingType, setSelectedBillingType] = useState("By Role");
  const [webRoleOptions, setWebRoleOptions] = useState<any[]>([]);
  const [selectedRole, setSelectedRole] = useState("");
  const [userOptions, setUserOptions] = useState<any[]>([]);
  const [userData, setUserData] = useState<UserOptiopn[]>([]);
  const [userSearchQuery, setUserSearchQuery] = useState<string>("");
  const [selectedUser, setSelectedUser] = useState<any>(null);
  const [selectedUserName, setSelectedUserName] = useState("");
  const [casePriorityOptions, setCasePriorityOptions] = useState<any[]>([]);
  const [selectedCasePriority, setSelectedCasePriority] = useState<
    string | number
  >("");
  const [caseTypeOptions, setCaseTypeOptions] = useState<any[]>([]);
  const [selectedCaseType, setSelectedCaseType] = useState<(string | number)[]>(
    [],
  );
  const [examTypeOptions, setExamTypeOptions] = useState<any[]>([]);
  const [selectedExamType, setSelectedExamType] = useState<(string | number)[]>(
    [],
  );
  const [rateType, setRateType] = useState("Fixed");
  const [currencyOptions, setCurrencyOptions] = useState<any[]>([]);
  const [selectedCurrency, setSelectedCurrency] = useState("USD");
  const [selectedCurrencyLabel, setSelectedCurrencyLabel] = useState("USD");
  const [fixedAmount, setFixedAmount] = useState("");
  const [isInputPages, setIsInputPages] = useState<any>("Output");

  const [isTranscriber, setIsTranscriber] = useState(false);

  const addDays = (date: Date, days: number) => {
    const result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  };

  const addYears = (date: Date, years: number) => {
    const result = new Date(date);
    result.setFullYear(result.getFullYear() + years);
    return result;
  };

  const [effectiveDateFrom, setEffectiveDateFrom] = useState<Date | null>(
    new Date(),
  );
  const [effectiveDateTo, setEffectiveDateTo] = useState<Date | null>(null);
  const [isActive, setIsActive] = useState(true);
  const [comments, setComments] = useState("");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [thresholdPageData, setThresholdPageData] = useState<any[]>([]);
  const [thresholdLineData, setThresholdLineData] = useState<any[]>([]);
  const [thresholdErrors, setThresholdErrors] = useState<string[]>([]);
  const [thresholdLineErrors, setThresholdLineErrors] = useState<string[]>([]);
  const [changeLogData, setChangeLogData] = useState<any[]>([]);
  const [showTooltip, setShowTooltip] = useState(false);
  const [showChangeDrawer, setShowChangeDrawer] = useState(false);
  const [showModalNew, setShowModalNew] = useState<boolean>(false);
  const [isCancelRequest, setIsCancelRequest] = useState<boolean>(false);
  const [createdOn, setCreatedOn] = useState("");
  const [createdBy, setCreatedBy] = useState("");
  const [configurationBillingKey, setConfigurationBillingKey] = useState<
    string | null
  >("0");
  const [pageThresholdKey, setPageThresholdKey] = useState<string | null>("0");
  const dropdownRef = useRef<HTMLDivElement>(null);
  const billingType = selectedData?.billingTeamConfigId
    ? "TEAM"
    : selectedData?.billingConfigId
      ? "SYSTEM"
      : selectedData?.billingCaseConfigId
        ? "CASE"
        : "TEAM";

  const billingId =
    selectedData?.billingTeamConfigId ??
    selectedData?.billingConfigId ??
    selectedData?.billingCaseConfigId ??
    null;

  const disablebillingId =
    selectedData?.billingConfigId ??
    selectedData?.billingCaseConfigId ??
    null;

  const [resetKey, setResetKey] = useState(0);
  const isEditMode = Boolean(billingId);

  const formattedStringPerPage = thresholdPageData
    .map((d) => `${d.isInputPage},${d.min},${d.max},${d.rate}`)
    .join(" | ");

  const formattedStringPerLine = thresholdLineData
    .map((d) => `${d.min},${d.max},${d.rate}`)
    .join(" | ");

  const params = {
    webRole: {
      groupName: PICKLIST_GROUP_NAME.Web_Application_Role,
      triggerById: userID,
    },
    caseType: {
      groupName: PICKLIST_GROUP_NAME.Case_Review_Type,
      triggerById: userID,
    },
    examType: {
      groupName: PICKLIST_GROUP_NAME.Appointment_Type,
      triggerById: userID,
    },
    casePriority: {
      groupName: PICKLIST_GROUP_NAME.Case_Priority,
      triggerById: userID,
    },
  };

  useEffect(() => {
    if (effectiveDateFrom && !selectedData) {
      setEffectiveDateTo(addYears(effectiveDateFrom, 1));
    }
  }, [effectiveDateFrom]);

  const currencyData = [
    {
      label: "USD",
      value: "USD",
    },
    {
      label: "INR",
      value: "INR",
    },
  ];

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [webRoleData, casePriorityData, caseTypeData, examTypeData] =
          await Promise.all([
            fetchPickListByGroupName(params.webRole),
            fetchPickListByGroupName(params.casePriority),
            fetchPickListByGroupName(params.caseType),
            fetchPickListByGroupName(params.examType),
          ]);

        const allowedRoles = [
          WEB_ROLE.Historian,
          WEB_ROLE.Editor,
          WEB_ROLE.Record_Reviewer,

          WEB_ROLE.Case_Manager,
          WEB_ROLE.QME_DoctorPMC,
          WEB_ROLE.Transcriber,
          WEB_ROLE.Medical_Assistant,
          WEB_ROLE.IndependentQMEDoctor,
          WEB_ROLE.Practice_Manager,
        ];

        const filteredRoles =
          webRoleData?.filter((role: any) =>
            allowedRoles.includes(role.label),
          ) || [];

        setWebRoleOptions(filteredRoles);
        setCasePriorityOptions(casePriorityData || []);
        setSelectedCasePriority(casePriorityData?.[0]?.value);
        setCaseTypeOptions(caseTypeData || []);
        setExamTypeOptions(examTypeData || []);
        setCurrencyOptions(currencyData);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setUserData([]);
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  const parsePageSlabsText = (text: string) => {
    if (!text) return { slabs: [], pageType: "Input" as "Input" | "Output" };

    const rows = text
      .split("|")
      .map((r) => r.trim())
      .filter(Boolean);

    const slabs = rows.map((row) => {
      const [isInput, min, max, rate] = row.split(",");

      return {
        isInputPage: Number(isInput) as 0 | 1,
        min: Number(min),
        max: Number(max),
        rate: Number(rate),
      };
    });

    const pageType = slabs[0]?.isInputPage === 1 ? "Input" : "Output";

    return { slabs, pageType };
  };

  const parseThresholdLineString = (data?: string) => {
    if (!data) return [];

    return data.split("|").map((chunk) => {
      const [min, max, rate] = chunk.trim().split(",");

      return {
        min: Number(min),
        max: Number(max),
        rate: Number(rate),
      };
    });
  };

  const [billingSnapshot, setBillingSnapshot] = useState<{
    rateType:
      | "Fixed"
      | "Fixed Per Page"
      | "Fixed Per Line"
      | "Per Page"
      | "Per Line"
      | "";
    fixedAmount: string | null;
    pageAmount: string | null;
    lineAmount: string | null;
    pageType: any;
    pageSlabs: any[];
    lineSlabs: any[];
  } | null>(null);

  const getBillingDetails = async () => {
    try {
      setLoading(true);
      let billingData: any = null;
      let billingConfigId: number | null = null;
      let billingChangeLogData: any = null;

      if (selectedData?.billingConfigId) {
        billingConfigId = selectedData.billingConfigId;
        billingData = await fetchBillingConfigurationDetails(billingConfigId);
        billingChangeLogData = await getBillingConfigChangeLog(billingConfigId);
      } else if (selectedData?.billingTeamConfigId) {
        billingConfigId = selectedData.billingTeamConfigId;
        billingData = await fetchTeamBillingDetails(billingConfigId);
        billingChangeLogData = await getTeamBillingChangeLog(billingConfigId);
      } else if (selectedData?.billingCaseConfigId) {
        billingConfigId = selectedData.billingCaseConfigId;
        billingData = await getCaseLevelBillingDetails(billingConfigId);
        billingChangeLogData =
          await getCaseLevelBillingChangeLog(billingConfigId);
      }

      if (!billingData) return;

      if (billingData) {
        setSelectedBillingType(
          selectedData.billingType == "Role" ? "By Role" : "By User",
        );

        setSelectedRole(
          selectedData.billingType == "Role" && billingData.webRoleId
            ? billingData.webRoleId
            : null,
        );

        if (billingData.billingForUserFullName) {
          setSelectedUser({
            userId: billingData.userId ?? null,
            tenantId: billingData.tenantId ?? null,
            usfUlNameRole: billingData.billingForUserFullName,
          });
        }

        setSelectedCasePriority(
          billingData.priorityId ? billingData.priorityId : null,
        );

        setSelectedCaseType(
          billingData.caseTypeIdCsv
            ? billingData.caseTypeIdCsv.split(",").map(Number)
            : [],
        );

        setSelectedExamType(
          billingData.examTypeIdCsv
            ? billingData.examTypeIdCsv.split(",").map(Number)
            : [],
        );

        const getRateType =
          billingData.rateType == "Fixed" && billingData.flatRate > 0
            ? "Fixed"
            : billingData.rateType == "Fixed" && billingData.flatRatePerPage > 0
              ? "Fixed Per Page"
              : billingData.rateType == "Fixed" &&
                  billingData.flatRatePerLine > 0
                ? "Fixed Per Line"
                : billingData.rateType == "PER_PAGE"
                  ? "Per Page"
                  : billingData.rateType == "PER_LINE"
                    ? "Per Line"
                    : "";

        setRateType(getRateType);

        setSelectedCurrency(
          billingData.currencyType ? billingData.currencyType : null,
        );

        const getFixedAmount =
          billingData.rateType == "Fixed" && billingData.flatRate
            ? billingData.flatRate
            : billingData.rateType == "Fixed" && billingData.flatRatePerPage
              ? billingData.flatRatePerPage
              : billingData.rateType == "Fixed" && billingData.flatRatePerLine
                ? billingData.flatRatePerLine
                : "";

        setFixedAmount(getFixedAmount > 0 ? getFixedAmount : "");

        const { slabs, pageType } = parsePageSlabsText(
          billingData.page_slabs_text,
        );

        setIsInputPages(getRateType == "Per Page" ? pageType : "");
        setThresholdPageData(getRateType == "Per Page" ? slabs : []);

        const parsedLine = parseThresholdLineString(
          billingData.line_slabs_text,
        );

        setThresholdLineData(getRateType == "Per Line" ? parsedLine : []);

         setBillingSnapshot({
          rateType: getRateType,
          fixedAmount: billingData.flatRate > 0 ? billingData.flatRate : null,
          pageAmount:
            billingData.flatRatePerPage > 0
              ? billingData.flatRatePerPage
              : null,
          lineAmount:
            billingData.flatRatePerLine > 0
              ? billingData.flatRatePerLine
              : null,
          pageType,
          pageSlabs: slabs,
          lineSlabs: parsedLine,
        });
        
        setEffectiveDateFrom(
          billingData.effectiveStartDate
            ? billingData.effectiveStartDate
            : null,
        );
        setEffectiveDateTo(
          billingData.effectiveEndDate ? billingData.effectiveEndDate : null,
        );
        setComments(billingData.comments ? billingData.comments : null);
        setIsActive(billingData?.isActive === 1);
        setCreatedOn(
          billingData.createdDate
            ? formatAppointmentDateTime(billingData.createdDate)
            : "",
        );

        setCreatedBy(
          billingData.createdByName ? billingData.createdByName : "",
        );

        if (billingChangeLogData) {
          const filteredLogData = billingChangeLogData?.filter(
            (item: any) =>
              !["modifieddate", "modifiedby"].includes(
                item.fieldName?.toLowerCase(),
              ),
          );

          setChangeLogData(filteredLogData);
        }
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (selectedData) {
      getBillingDetails();
    }
  }, [selectedData]);

  const handleSearchUser = async (e: ChangeEvent<HTMLInputElement>) => {
    const query = e.target.value;

    if (query.startsWith(" ")) return;

    setSelectedUser(null);
    setUserSearchQuery(query);

    const trimmedQuery = query.trim();
    if (trimmedQuery?.length < 3) {
      setUserData([]);
      return;
    }

    try {
      const payload = { teamId: teamId, searchString: trimmedQuery };
      const response: any = await fetchUerListByTeam(payload);
      setUserData(Array.isArray(response?.result) ? response.result : []);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const [userRole, setUserRole] = useState("");

  const getloggedInUserRole = async () => {
    try {
      const userRole = await fetcheaderinfo(selectedUser.userId);
      setUserRole(userRole.userroledescription);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    getloggedInUserRole();
  }, [selectedUser]);

  const selectedRoleLabel = webRoleOptions.find(
    (role) => role.value === selectedRole,
  )?.label;

  const isRecordReviewer = userRole.toLowerCase().includes("record reviewer");

  const isSlabDisable = selectedRoleLabel == WEB_ROLE.Record_Reviewer;

  useEffect(() => {
    if (userRole) {
      setIsTranscriber(userRole.toLowerCase().includes("transcriber"));
    } else {
      setIsTranscriber(false);
    }
  }, [userRole]);

  const isSelectedTranscriber = selectedRoleLabel === WEB_ROLE.Transcriber;
  const shouldDisableCurrency = !(isSelectedTranscriber || isTranscriber);

  const handleSelectUser = (option: any) => {
    setSelectedUser(option);
    setUserSearchQuery("");
    setUserData([]);
    if (isRecordReviewer) {
      setIsInputPages("Output");
    }

    if (!isSlabDisable) {
      setIsInputPages("Output");
      setThresholdPageData([]);
    }
  };

  const handleRoleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const value = e.target.value;
    setSelectedRole(value);
    const selectedRoleLabel = webRoleOptions.find(
      (role) => role.value === value,
    )?.label;

    if (selectedRoleLabel != WEB_ROLE.Record_Reviewer) {
      setIsInputPages("Output");
      setThresholdPageData([]);
    }
  };

  const handleBillingTypeChange = (val: string) => {
    setSelectedBillingType(val);
    setSelectedRole("");
    setUserData([]);
    setSelectedUser(null);

    setIsTranscriber(false);
  };

  const handleCasePriorityChange = (val: string | number) => {
    setSelectedCasePriority(val);
  };

  const handleRateTypeChange = (
    newType:
      | "Fixed"
      | "Fixed Per Page"
      | "Fixed Per Line"
      | "Per Page"
      | "Per Line",
  ) => {
    setRateType(newType);

    if (!isEditMode) {
      setFixedAmount("");
      setThresholdPageData([]);
      setThresholdLineData([]);
      setThresholdErrors([]);
      setThresholdLineErrors([]);
      setResetKey((k) => k + 1);
      return;
    }

    if (!billingSnapshot) return;

    setFixedAmount("");
    setThresholdPageData([]);
    setThresholdLineData([]);

    if (newType === "Fixed") {
      setFixedAmount(billingSnapshot.fixedAmount ?? "");
    }

    if (newType === "Fixed Per Page") {
      setFixedAmount(billingSnapshot.pageAmount ?? "");
    }
    if (newType === "Fixed Per Line") {
      setFixedAmount(billingSnapshot.lineAmount ?? "");
    }

    if (newType === "Per Page") {
      setIsInputPages(billingSnapshot.pageType);
      setThresholdPageData(billingSnapshot.pageSlabs);
    }

    if (newType === "Per Line") {
      setThresholdLineData(billingSnapshot.lineSlabs);
    }

    setResetKey((k) => k + 1);
  };


  const handlePagesTypeChange = (newPageType: any) => {
    setIsInputPages(newPageType);

    if (!isEditMode) {
      setThresholdPageData([]);
      setThresholdErrors([]);
      setResetKey((k) => k + 1);
      return;
    }
  };

  const handleCurrencyChange = (e: any) => {
    const selectedValue = e.target.value;

    const selectedOption = currencyOptions.find(
      (opt) => String(opt.value) === String(selectedValue),
    );

    setSelectedCurrency(selectedValue);
    setSelectedCurrencyLabel(selectedOption?.label || "");
  };

  const handleIsActive = () => {
    setIsActive((prev) => !prev);
  };

  const resetBillingState = () => {
    setSelectedBillingType("By Role");
    setSelectedRole("");
    setSelectedUser(null);
    setUserSearchQuery("");
    setUserData([]);
    setSelectedCasePriority("");
    setSelectedCaseType([]);
    setSelectedExamType([]);
    setRateType("Fixed");
    setSelectedCurrency("USD");
    setSelectedCurrencyLabel("USD");
    setFixedAmount("");
    setIsInputPages("Output");
    setThresholdPageData([]);
    setThresholdLineData([]);
    setThresholdErrors([]);
    setThresholdLineErrors([]);
    setEffectiveDateFrom(new Date());
    setEffectiveDateTo(addYears(new Date(), 1));
    setIsActive(true);
    setComments("");
  };

  const handleCancelButton = () => {
    setShowModalNew(true);
  };

  const handleClose = () => {
    setIsCancelRequest(false);
    onClose(billingType);
  };

  const handleCloseModalNew = () => {
    setShowModalNew(false);
  };

  const handleConfirmCancelButton = () => {
    if (selectedData) {
      getBillingDetails();
      setIsCancelRequest(true);
    } else {
      resetBillingState();
    }
    setShowModalNew(false);
  };

  const validateConfiguration = () => {
    const errors = [];

    if (selectedBillingType == "By Role" && !selectedRole) {
      errors.push("Please select User Role.");
    }

    if (selectedBillingType == "By User" && !selectedUser) {
      errors.push("Please select User Name.");
    }

    if (!selectedCaseType || selectedCaseType?.length === 0) {
      errors.push("Case Type is mandatory.");
    }

    if (!selectedExamType || selectedExamType?.length === 0) {
      errors.push("Exam Type is mandatory.");
    }

    if (!selectedCurrency || selectedCurrency?.length === 0) {
      errors.push("Currency is mandatory.");
    }
    if (
      rateType == "Fixed" ||
      rateType == "Fixed Per Page" ||
      rateType == "Fixed Per Line"
    ) {
      if (selectedCurrency && !fixedAmount) {
        errors.push("Amount is mandatory.");
      }

      if (selectedCurrency) {
        if (
          fixedAmount === null ||
          fixedAmount === undefined ||
          fixedAmount === "" ||
          Number(fixedAmount) === 0
        ) {
          errors.push("Amount cannot be zero.");
        }
      }
    }

    const hasInvalidRateWhenMinMaxPresent = (data: any[]) =>
      data.some(
        (item) =>
          item.min !== null &&
          item.min !== undefined &&
          item.min !== 0 &&
          item.max !== null &&
          item.max !== undefined &&
          item.max !== 0 &&
          (item.rate === 0 ||
            item.rate === null ||
            item.rate === undefined ||
            item.rate === ""),
      );

    if (rateType == "Per Page") {
      if (!thresholdPageData || thresholdPageData?.length === 0) {
        errors.push("Please Add atleast one slab for per page");
      } else if (hasInvalidRateWhenMinMaxPresent(thresholdPageData)) {
        errors.push("Amount must be greater than 0.");
      }
    }

    if (rateType == "Per Line") {
      if (!thresholdLineData || thresholdLineData?.length === 0) {
        errors.push("Please Add atleast one slab for per line");
      } else if (hasInvalidRateWhenMinMaxPresent(thresholdLineData)) {
        errors.push("Amount must be greater than 0.");
      }
    }

    if (errors?.length > 0) {
      setSnackbarMessage(errors.join("\n"));
      setSnackbarOpen(true);
      setError("error");
      return false;
    }

    return true;
  };

  const validateThreshold = () => {
    const errors = [];

    if (rateType == "Per Page") {
      if (thresholdErrors?.length > 0) {
        errors.push(...thresholdErrors);
      }
    }

    if (errors?.length > 0) {
      setSnackbarMessage(errors.join("\n"));
      setSnackbarOpen(true);
      setError("error");
      return false;
    }

    return true;
  };

  const validateLineThreshold = () => {
    const errors = [];

    if (rateType == "Per Line") {
      if (thresholdLineErrors?.length > 0) {
        errors.push(...thresholdLineErrors);
      }
    }

    if (errors?.length > 0) {
      setSnackbarMessage(errors.join("\n"));
      setSnackbarOpen(true);
      setError("error");
      return false;
    }

    return true;
  };

  useEffect(() => {
    if (thresholdErrors?.length > 0) {
      validateThreshold();
    }
  }, [thresholdErrors]);

  useEffect(() => {
    if (thresholdLineErrors?.length > 0) {
      validateLineThreshold();
    }
  }, [thresholdLineErrors]);

  const getRateTypeForPayload = (rateType: string) => {
    switch (rateType) {
      case "Fixed":
      case "Fixed Per Page":
      case "Fixed Per Line":
        return RATE_TYPE.FLAT;
      case "Per Page":
        return RATE_TYPE.PER_PAGE;
      case "Per Line":
        return RATE_TYPE.PER_LINE;
      default:
        return rateType;
    }
  };

  const handleSave = async () => {
    if (!validateConfiguration()) return;
    setLoading(true);
    try {
      const isBillingConfigUpdate = !!selectedData?.billingConfigId;
      const isTeamBillingUpdate = !!selectedData?.billingTeamConfigId;
      const payload: any = {
        // ...(isBillingConfigUpdate && {
        //   billingConfigId: selectedData.billingConfigId,
        // }),
        ...(isBillingConfigUpdate && {
          masterBillingConfigId: selectedData.billingConfigId || null,
        }),
        ...(isTeamBillingUpdate && {
          billingTeamConfigId: selectedData.billingTeamConfigId,
          // masterBillingConfigId: selectedData?.masterBillingConfigId || null,
        }),
        teamId,
        webRoleId: selectedRole ? selectedRole : null,
        userId: selectedUser ? selectedUser.userId : null,
        priorityId: Number(selectedCasePriority),
        effectiveStartDate: effectiveDateFrom
          ? formatDateTime(effectiveDateFrom)
          : null,
        effectiveEndDate: effectiveDateTo
          ? formatDateTime(effectiveDateTo)
          : null,
        caseTypeIdCsv: selectedCaseType.join(","),
        examTypeIdCsv: selectedExamType.join(","),
        rateType: getRateTypeForPayload(rateType),
        currencyType: selectedCurrency,
        flatRate: rateType == "Fixed" ? fixedAmount : 0,
        flatRatePerPage: rateType == "Fixed Per Page" ? fixedAmount : 0,
        flatRatePerLine: rateType == "Fixed Per Line" ? fixedAmount : 0,
        isPageThresholdAppl: rateType == "Per Page" ? 1 : 0,
        comments: comments,
        billingConfigStatus: isActive ? 1 : 0,
        modifiedBy: userID,
        createdBy: userID,
        pageSlabsText: rateType == "Per Page" ? formattedStringPerPage : null,
        lineSlabsText: rateType == "Per Line" ? formattedStringPerLine : null,
      };

      const apiToCall = isBillingConfigUpdate
        ? addTeamBilling
        : isTeamBillingUpdate
          ? updateTeamBilling
          : addTeamBilling;

      const successMessage = isBillingConfigUpdate
        ? "Billing Configuration Override Successfully"
        : isTeamBillingUpdate
          ? "Team Billing update Successfully"
          : "Team Billing Added Successfully";

      const response = await apiToCall(payload);

      if (response.isSuccess) {
        setSnackbarMessage(successMessage);
        setError("success");
        setSnackbarOpen(true);
        setTimeout(() => {
          onClose(billingType);
        }, 800);
      } else {
        setSnackbarMessage(response?.message || "Failed to process data.");
        setError("error");
        setSnackbarOpen(true);
      }
    } catch (error) {
      setSnackbarMessage("An unexpected error occurred.");
      setError("error");
      setSnackbarOpen(true);
    } finally {
      setLoading(false);
    }
  };

  const handleOpenChangeDrawer = async () => {
    if (selectedData) {
      setShowTooltip(false);
      setShowChangeDrawer(true);
    }
  };

  const handleCloseChangeDrawer = () => {
    setShowChangeDrawer(false);
  };

  const handleAccordionSelect = (key: string | null) => {
    if (configurationBillingKey === key) {
      return;
    }
    setConfigurationBillingKey(key || "0");
  };

  const configurationAccordion = (
    items: { title: string; content: JSX.Element }[],
  ) => (
    <AccordionComponent
      items={items.map((item) => ({ ...item }))}
      activeKey={configurationBillingKey}
      onSelect={handleAccordionSelect}
    />
  );

  const thresholdAccordion = (
    items: { title: string; content: JSX.Element }[],
  ) => (
    <AccordionComponent
      items={items.map((item) => ({ ...item }))}
      activeKey={pageThresholdKey}
      onSelect={(key) => setPageThresholdKey(key as string)}
    />
  );

  const fixedSelected = ["Fixed", "Fixed Per Page", "Fixed Per Line"].includes(
    rateType,
  );

  return (
    <div>
      {" "}
      <div className="mt-4 mb-5">
        <Loader isLoading={loading} />
        <Snackbar
          open={snackbarOpen}
          message={snackbarMessage}
          onClose={() => setSnackbarOpen(false)}
          severity={error}
        />

        <div className="container-fluid px-5">
          {configurationAccordion([
            {
              title: "Configure Billing",
              content: (
                <>
                  {!selectedData?.billingCaseConfigId ? (
                    <Row className="align-items-center mt-0">
                      <div className="col-md-6 col-xxl-4 d-flex align-items-center gap-5">
                        <Col xs="auto" className="fw-semibold form-label mb-0">
                          Billing
                        </Col>
                        <Col xs="auto" className="px-2">
                          <ToggleButtonGroup
                            type="radio"
                            name="billingType"
                            value={selectedBillingType}
                            onChange={handleBillingTypeChange}
                            className="appointment-ui d-flex adjust adjust_pills_xs"
                          >
                            <ToggleButton
                              id="billing-role"
                              variant="outline-secondary"
                              value="By Role"
                              className="px-4"
                              disabled={selectedData}
                            >
                              By Role
                            </ToggleButton>

                            <ToggleButton
                              id="billing-user"
                              variant="outline-secondary"
                              value="By User"
                              className="px-3"
                              disabled={selectedData}
                            >
                              By User
                            </ToggleButton>
                          </ToggleButtonGroup>
                        </Col>
                      </div>

                      <div className="col-md-3">
                        {/* Conditional Field */}
                        {selectedBillingType === "By Role" ? (
                          <Col className="selection_dropdown">
                            <SearchableSingleSelectDropdown
                              label="Role"
                              value={selectedRole}
                              options={webRoleOptions}
                              onChange={handleRoleChange}
                              name="webRoleID"
                              required={true}
                              disabled={selectedData}
                            />
                          </Col>
                        ) : (
                          <Col>
                            <div className="form-floating" ref={dropdownRef}>
                              <input
                                type="text"
                                name="User Name"
                                className="form-control zipcodeDetailsOverlay"
                                placeholder="Search User"
                                maxLength={50}
                                value={
                                  selectedUser
                                    ? selectedUser.usfUlNameRole
                                    : userSearchQuery
                                }
                                onChange={handleSearchUser}
                                autoComplete="off"
                                required
                                disabled={selectedData}
                              />
                              <label>
                                User Name <span className="text-danger">*</span>
                              </label>

                              {userData.length > 0 && (
                                <div className="dropdown-results">
                                  <ul
                                    className="list-group"
                                    style={{
                                      maxHeight: "200px",
                                      overflowY: "auto",
                                    }}
                                  >
                                    {userData.map((option) => (
                                      <li
                                        key={option.userId}
                                        className="list-group-item d-flex align-items-center gap-2"
                                        style={{ cursor: "pointer" }}
                                        onClick={() => handleSelectUser(option)}
                                      >
                                        <input
                                          type="radio"
                                          name="location"
                                          checked={
                                            selectedUser?.usfUlNameRole ===
                                            option.usfUlNameRole
                                          }
                                          onChange={() =>
                                            handleSelectUser(option)
                                          }
                                        />
                                        <span>{option.usfUlNameRole}</span>
                                      </li>
                                    ))}
                                  </ul>
                                </div>
                              )}
                            </div>
                          </Col>
                        )}
                      </div>
                    </Row>
                  ) : (
                    <Row className="align-items-center mt-0 g-2">
                      <Col sm={3}>
                        <div className="form-floating" ref={dropdownRef}>
                          <input
                            type="text"
                            name="User"
                            className="form-control zipcodeDetailsOverlay"
                            placeholder="Search User"
                            maxLength={50}
                            value={
                              selectedUser
                                ? selectedUser.usfUlNameRole
                                : userSearchQuery
                            }
                            onChange={handleSearchUser}
                            autoComplete="off"
                            required
                            disabled={selectedData}
                          />
                          <label>User Name</label>
                        </div>
                      </Col>
                    </Row>
                  )}

                  {!selectedData?.billingCaseConfigId ? (
                    <Row className="align-items-center mt-3">
                      <div className="col-md-6 col-xxl-4">
                        <div className="d-flex align-items-center gap-2">
                          <Col
                            xs="auto"
                            className="fw-semibold ps-1 form-label-fixed mb-0"
                          >
                            Case Priority
                          </Col>

                          <Col xs="auto">
                            <ToggleButtonGroup
                              type="radio"
                              name="casePriority"
                              value={selectedCasePriority}
                              onChange={handleCasePriorityChange}
                              className="appointment-ui adjust_pills_xs"
                            >
                              {casePriorityOptions.map((opt) => (
                                <ToggleButton
                                  key={opt.value}
                                  id={`priority-${opt.value}`}
                                  variant="outline-secondary"
                                  value={opt.value}
                                  className="px-3"
                                  disabled={disablebillingId}
                                >
                                  {opt.label}
                                </ToggleButton>
                              ))}
                            </ToggleButtonGroup>
                          </Col>
                        </div>
                      </div>

                      <Col sm={3} className="selection_dropdown">
                        <SearchableMultiSelectDropdown
                          label="Case Type"
                          name="caseType"
                          options={caseTypeOptions}
                          values={selectedCaseType}
                          onChange={(e, name, values) =>
                            setSelectedCaseType(values)
                          }
                          required
                          disabled={disablebillingId}
                        />
                      </Col>
                      <Col sm={3} className="selection_dropdown">
                        <SearchableMultiSelectDropdown
                          label="Exam Type"
                          name="examType"
                          options={examTypeOptions}
                          values={selectedExamType}
                          onChange={(e, name, values) =>
                            setSelectedExamType(values)
                          }
                          required
                          disabled={disablebillingId}
                        />
                      </Col>
                    </Row>
                  ) : (
                    ""
                  )}
                  <Row className="align-items-center mt-3">
                    <div className="col-md-6 col-xxl-4">
                      <div className="rate-type-wrapper">
                        {/* Fixed */}
                        <div className="rate-type-block adjust_spacingToggle">
                          <div className="rate-type-label">
                            Rate Type (Fixed)
                            <span style={{ color: "#0092d5" }}>
                              {fixedSelected ? " Selected" : ""}
                            </span>
                          </div>

                          <ToggleButtonGroup
                            type="radio"
                            name="rateTypeMain"
                            value={rateType}
                            onChange={handleRateTypeChange}
                            className="appointment-ui adjust_pills_xs"
                          >
                            <ToggleButton
                              id="fixed-rate"
                              variant="outline-secondary"
                              value="Fixed"
                              className="px-3"
                              disabled={disablebillingId}
                            >
                              Fixed
                            </ToggleButton>

                            <ToggleButton
                              id="per-page-main"
                              variant="outline-secondary"
                              value="Fixed Per Page"
                              className="px-3"
                              disabled={disablebillingId}
                            >
                              Per Page
                            </ToggleButton>

                            <ToggleButton
                              id="per-line-main"
                              variant="outline-secondary"
                              value="Fixed Per Line"
                              className="px-3"
                              disabled={disablebillingId}
                            >
                              Per Line
                            </ToggleButton>
                          </ToggleButtonGroup>
                        </div>

                        {/* Pipe */}
                        <div className="rate-type-pipe">||</div>

                        {/* Slab */}
                        <div className="rate-type-block">
                          <div className="rate-type-label">
                            Rate Type (Slab)
                            <span style={{ color: "#0092d5" }}>
                              {!fixedSelected ? " Selected" : ""}
                            </span>
                          </div>

                          <ToggleButtonGroup
                            type="radio"
                            name="rateTypeSlab"
                            value={rateType}
                            onChange={handleRateTypeChange}
                            className="appointment-ui adjust_pills_xs"
                          >
                            <ToggleButton
                              id="per-page-slab"
                              variant="outline-secondary"
                              value="Per Page"
                              className="px-3"
                              disabled={disablebillingId}
                            >
                              Per Page
                            </ToggleButton>

                            <ToggleButton
                              id="per-line-slab"
                              variant="outline-secondary"
                              value="Per Line"
                              className="px-3"
                              disabled={disablebillingId}
                            >
                              Per Line
                            </ToggleButton>
                          </ToggleButtonGroup>
                        </div>
                      </div>
                    </div>

                    <Col sm={3} className="selection_dropdown">
                      <SearchableSingleSelectDropdown
                        label="Currency"
                        value={selectedCurrency}
                        options={currencyOptions}
                        onChange={handleCurrencyChange}
                        name="currencyID"
                        required={true}
                        disabled={disablebillingId}
                      />
                    </Col>
                    {rateType == "Fixed" ||
                    rateType == "Fixed Per Page" ||
                    rateType == "Fixed Per Line" ? (
                      <Col sm={3}>
                        <NumberInput
                          label="Amount"
                          name="amount"
                          value={fixedAmount}
                          onChange={(e) => setFixedAmount(e.target.value)}
                          allowDecimal={true}
                          limit={[8, 2]}
                          disabled={
                            !selectedCurrency ||
                            selectedData?.billingCaseConfigId
                          }
                          showAmountLabel={true}
                          amountLabel={selectedCurrencyLabel}
                        />
                      </Col>
                    ) : null}
                    {rateType === "Per Page" && (
                      <>
                        <Col
                          sm="3"
                          className="fw-semibold ps-1 form-label-fixed d-flex align-items-center adjust_spacingToggle"
                        >
                          Slab Apply on Pages
                          <ToggleButtonGroup
                            type="radio"
                            name="inputPagesType"
                            value={isInputPages}
                            onChange={handlePagesTypeChange}
                            className="appointment-ui adjust_pills_xs"
                          >
                            <ToggleButton
                              id="input-page"
                              variant="outline-secondary"
                              value="Input"
                              className="px-3"
                              disabled={
                                disablebillingId ||
                                (!isSlabDisable && !isRecordReviewer)
                              }
                            >
                              Input
                            </ToggleButton>

                            <ToggleButton
                              id="output-page"
                              variant="outline-secondary"
                              value="Output"
                              className="px-3"
                              disabled={
                                disablebillingId ||
                                (!isSlabDisable && !isRecordReviewer)
                              }
                            >
                              Output
                            </ToggleButton>
                          </ToggleButtonGroup>
                        </Col>
                      </>
                    )}
                  </Row>

                  {rateType == "Per Page" ? (
                    <Row className="align-items-center mt-3">
                      {thresholdAccordion([
                        {
                          title:
                            isInputPages === "Input"
                              ? "Input Page Slab"
                              : "Output Page Slab",
                          content: disablebillingId ? (
                            <BillingTeamsEditableTable
                              isInputPages={isInputPages}
                              value={thresholdPageData}
                              onChange={setThresholdPageData}
                              onValidationError={setThresholdErrors}
                              isCaseBilling={
                                !!selectedData?.billingCaseConfigId
                              }
                              isCancel={isCancelRequest}
                            />
                          ) : (
                            <ThresholdEditableTable
                              resetKey={resetKey}
                              isInputPages={isInputPages}
                              value={thresholdPageData}
                              onChange={setThresholdPageData}
                              onValidationError={setThresholdErrors}
                            />
                          ),
                        },
                      ])}
                    </Row>
                  ) : null}
                  {rateType == "Per Line" ? (
                    <Row className="align-items-center mt-3">
                      {thresholdAccordion([
                        {
                          title: "Line Slab",
                          content: disablebillingId ? (
                            <BillingTeamsEditableTable
                              value={thresholdLineData}
                              onChange={setThresholdLineData}
                              onValidationError={setThresholdLineErrors}
                              isCaseBilling={
                                !!selectedData?.billingCaseConfigId
                              }
                              isCancel={isCancelRequest}
                            />
                          ) : (
                            <ThresholdLineEditable
                              resetKey={resetKey}
                              value={thresholdLineData}
                              onChange={setThresholdLineData}
                              onValidationError={setThresholdLineErrors}
                            />
                          ),
                        },
                      ])}
                    </Row>
                  ) : null}

                  <Row className="align-items-center mt-3">
                    {!selectedData?.billingCaseConfigId ? (
                      <>
                        <div className="col-md-3 col-xxl-2">
                          <FloatingLabelDatepicker
                            ref={datePickerRef}
                            label="Effective Date From"
                            name="effectiveDateFrom"
                            value={effectiveDateFrom}
                            onChange={(date: Date | null) => {
                              setEffectiveDateFrom(date);
                            }}
                            required
                            dateFormat="MM/dd/yyyy"
                            maxDate={effectiveDateTo || undefined}
                            disabled={disablebillingId}
                          />
                        </div>

                        <div className="col-md-3 col-xxl-2">
                          <FloatingLabelDatepicker
                            ref={datePickerRef}
                            label="Effective Date To"
                            name="effectiveDateTo"
                            value={effectiveDateTo}
                            onChange={(date: Date | null) => {
                              setEffectiveDateTo(date);
                            }}
                            dateFormat="MM/dd/yyyy"
                            minDate={effectiveDateFrom || new Date()}
                            canClear={true}
                            disabled={disablebillingId}
                          />
                        </div>
                      </>
                    ) : (
                      ""
                    )}
                    <div className="col-md-4 col-sm-6">
                      <div className="d-flex align-items-center toggle-btn">
                        <span className="me-3 fw-semibold">Status</span>

                        <Form.Check
                          type="switch"
                          id="sort-switch"
                          checked={isActive}
                          onChange={handleIsActive}
                          disabled={selectedData?.billingCaseConfigId}
                        />
                        <span className="ms-2">
                          {isActive ? "Active" : "In Active"}
                        </span>
                      </div>
                    </div>
                  </Row>

                  <Col
                    sm={12}
                    className="mt-3 notemultiline notemultilinerushnote  mb-3"
                  >
                    <MultilineTextBox
                      label="Comments"
                      name="comments"
                      value={comments}
                      onChange={(e) => {
                        let value = e.target.value;
                        if (value.startsWith(" ")) return;
                        value = value?.trimStart();
                        value = value.replace(/ {2,}/g, " ");
                        setComments(value);
                      }}
                      maxLength={100}
                      disabled={disablebillingId}
                    />
                  </Col>
                  <Row className="mt-3 mb-3">
                    <Col sm={12} className="d-flex align-items-center">
                      {changeLogData?.length > 0 && selectedData && (
                        <OverlayTrigger
                          show={showTooltip}
                          placement="auto"
                          trigger={["hover", "focus"]}
                          delay={{ show: 200, hide: 100 }}
                          overlay={
                            <Tooltip style={{ backgroundColor: "#b3e0ff" }}>
                              Logs
                            </Tooltip>
                          }
                        >
                          <div className="d-flex">
                            <Button
                              type="button"
                              className="btn btn-primary d-flex align-items-center mx-2"
                              onClick={handleOpenChangeDrawer}
                              onMouseEnter={() => setShowTooltip(true)}
                              onMouseLeave={() => setShowTooltip(false)}
                            >
                              <span className="material-icons">
                                description
                              </span>
                            </Button>
                          </div>
                        </OverlayTrigger>
                      )}

                      <Button
                        variant="outline-info"
                        className="d-flex align-items-center me-auto btn-text-border"
                        onClick={handleClose}
                      >
                        <span className="material-icons me-1">arrow_back</span>
                        Back
                      </Button>

                      {!selectedData?.billingCaseConfigId ? (
                        <>
                          <Button
                            variant="outline-info"
                            className="d-flex align-items-center"
                            onClick={handleCancelButton}
                          >
                            <span className="material-icons me-1">close</span>
                            Cancel
                          </Button>

                          <Button
                            type="submit"
                            variant="primary"
                            className="ms-3 d-flex align-items-center"
                            onClick={handleSave}
                          >
                            <span
                              className={`${selectedData?.billingConfigId ? "material-symbols-outlined" : "material-icons"} me-1`}
                            >
                              {selectedData?.billingConfigId
                                ? "stack_star"
                                : "save"}
                            </span>

                            {selectedData?.billingConfigId
                              ? "Override"
                              : "Save"}
                          </Button>
                        </>
                      ) : (
                        ""
                      )}
                    </Col>
                  </Row>
                </>
              ),
            },
          ])}
        </div>
        <Modal show={showModalNew} onHide={handleCloseModalNew}>
          <Modal.Body className="fw-bold text-left modelheading ">
            <div>Are you sure you want to cancel?</div>
          </Modal.Body>
          <Modal.Footer className="border-top d-flex justify-content-end">
            <Button
              variant="outline-info"
              className="d-flex align-items-end"
              onClick={handleCloseModalNew}
            >
              <span className="material-icons mr-2">close</span> Cancel
            </Button>
            <Button
              onClick={handleConfirmCancelButton}
              variant="primary"
              className="ms-3 d-flex align-items-center"
            >
              <span className="material-icons mx-1">check</span> Confirm
            </Button>
          </Modal.Footer>
        </Modal>
        <ChangeLogDrawer
          title={"Change Log"}
          open={showChangeDrawer}
          onClose={handleCloseChangeDrawer}
          placement="bottom"
          data={changeLogData}
          createdOn={createdOn}
          createdBy={createdBy}
        >
          <BillingDataTable
            headers={
              selectedData?.billingCaseConfigId
                ? BILLINGCASE_CONFIG_CHANGE_LOG
                : BILLING_CONFIG_CHANGE_LOG
            }
            rows={changeLogData}
            isLogTable={true}
          />
        </ChangeLogDrawer>
      </div>
    </div>
  );
};

export default AddUpdateBilling;
